export default __webpack_public_path__ + "static/media/withFoodOn.2f6cf58b.svg";